import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from 'gunsi-auth'
import App from './App.jsx'
import './global.css'
import './tally.css'
import { applyTheme, loadThemePrefs } from './theme.js'
import { setupKbMeasure } from './measureKb.js'

// PWA attiva (vite-plugin-pwa autoUpdate in vite.config.js) — il vecchio
// unregister dei SW è stato rimosso il 2026-07-21.

const { theme, colorSet } = loadThemePrefs()
applyTheme(theme, colorSet)
setupKbMeasure()

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  const prefs = loadThemePrefs()
  if (prefs.theme === 'system') applyTheme('system', prefs.colorSet)
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>
)
